import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  <DModal
  class="flag-modal"
  @bodyClass="flag-modal-body"
  @title={{i18n this.title}}
  @submitOnEnter={{false}}
  @closeModal={{@closeModal}}
  {{on "keydown" this.onKeydown}}
>
  <:body>
    <form>
      <FlagSelection
        @nameKey={{this.selected.name_key}}
        @flags={{this.flagsAvailable}}
        as |f|
      >
        <FlagActionType
          @flag={{f}}
          @message={{this.message}}
          @isConfirmed={{this.isConfirmed}}
          @isWarning={{this.isWarning}}
          @selectedFlag={{this.selected}}
          @username={{@model.flagModel.username}}
          @staffFlagsAvailable={{this.staffFlagsAvailable}}
          @changePostActionType={{this.changePostActionType}}
        />
      </FlagSelection>
    </form>
    <PluginOutlet
      @name="flag-modal-bottom"
      @connectorTagName="div"
      @outletArgs={{hash post=@model.flagModel}}
    />
  </:body>
  <:footer>
    <DButton
      class="btn-primary flag-modal__create-flag"
      @action={{this.createFlag}}
      @disabled={{not this.submitEnabled}}
      @title="flagging.submit_tooltip"
      @icon={{if this.selected.is_custom_flag "envelope" "flag"}}
      @label={{this.submitLabel}}
    />

    {{#if this.canSendWarning}}
      <DButton
        class="btn-danger flag-modal__send-warning"
        @action={{this.createFlagAsWarning}}
        @disabled={{not this.submitEnabled}}
        @icon="exclamation-triangle"
        @label="flagging.official_warning"
      />
    {{/if}}

    {{#if this.canTakeAction}}
      <ReviewableBundledAction
        class="flag-modal__take-action"
        @bundle={{this.flagActions}}
        @performAction={{this.takeAction}}
        @reviewableUpdating={{not this.submitEnabled}}
      />

      <DButton
        class="btn-danger flag-modal__flag-for-review"
        @action={{this.flagForReview}}
        @disabled={{not this.submitEnabled this.notifyModeratorsFlag}}
        @icon="exclamation-triangle"
        @label="flagging.flag_for_review"
      />
    {{/if}}

    {{#if this.showDeleteSpammer}}
      <DButton
        class="btn-danger delete-spammer flag-modal__delete-spammer"
        @action={{this.deleteSpammer}}
        @disabled={{not this.submitEnabled}}
        @icon="exclamation-triangle"
        @label="flagging.delete_spammer"
      />
    {{/if}}
  </:footer>
</DModal>
*/
{
  "id": "lg/loF4m",
  "block": "[[[8,[39,0],[[24,0,\"flag-modal\"],[4,[38,2],[\"keydown\",[30,0,[\"onKeydown\"]]],null]],[[\"@bodyClass\",\"@title\",\"@submitOnEnter\",\"@closeModal\"],[\"flag-modal-body\",[28,[37,1],[[30,0,[\"title\"]]],null],false,[30,1]]],[[\"body\",\"footer\"],[[[[1,\"\\n    \"],[10,\"form\"],[12],[1,\"\\n      \"],[8,[39,3],null,[[\"@nameKey\",\"@flags\"],[[30,0,[\"selected\",\"name_key\"]],[30,0,[\"flagsAvailable\"]]]],[[\"default\"],[[[[1,\"\\n        \"],[8,[39,4],null,[[\"@flag\",\"@message\",\"@isConfirmed\",\"@isWarning\",\"@selectedFlag\",\"@username\",\"@staffFlagsAvailable\",\"@changePostActionType\"],[[30,2],[30,0,[\"message\"]],[30,0,[\"isConfirmed\"]],[30,0,[\"isWarning\"]],[30,0,[\"selected\"]],[30,3,[\"flagModel\",\"username\"]],[30,0,[\"staffFlagsAvailable\"]],[30,0,[\"changePostActionType\"]]]],null],[1,\"\\n      \"]],[2]]]]],[1,\"\\n    \"],[13],[1,\"\\n    \"],[8,[39,5],null,[[\"@name\",\"@connectorTagName\",\"@outletArgs\"],[\"flag-modal-bottom\",\"div\",[28,[37,6],null,[[\"post\"],[[30,3,[\"flagModel\"]]]]]]],null],[1,\"\\n  \"]],[]],[[[1,\"\\n    \"],[8,[39,7],[[24,0,\"btn-primary flag-modal__create-flag\"]],[[\"@action\",\"@disabled\",\"@title\",\"@icon\",\"@label\"],[[30,0,[\"createFlag\"]],[28,[37,8],[[30,0,[\"submitEnabled\"]]],null],\"flagging.submit_tooltip\",[52,[30,0,[\"selected\",\"is_custom_flag\"]],\"envelope\",\"flag\"],[30,0,[\"submitLabel\"]]]],null],[1,\"\\n\\n\"],[41,[30,0,[\"canSendWarning\"]],[[[1,\"      \"],[8,[39,7],[[24,0,\"btn-danger flag-modal__send-warning\"]],[[\"@action\",\"@disabled\",\"@icon\",\"@label\"],[[30,0,[\"createFlagAsWarning\"]],[28,[37,8],[[30,0,[\"submitEnabled\"]]],null],\"exclamation-triangle\",\"flagging.official_warning\"]],null],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,0,[\"canTakeAction\"]],[[[1,\"      \"],[8,[39,10],[[24,0,\"flag-modal__take-action\"]],[[\"@bundle\",\"@performAction\",\"@reviewableUpdating\"],[[30,0,[\"flagActions\"]],[30,0,[\"takeAction\"]],[28,[37,8],[[30,0,[\"submitEnabled\"]]],null]]],null],[1,\"\\n\\n      \"],[8,[39,7],[[24,0,\"btn-danger flag-modal__flag-for-review\"]],[[\"@action\",\"@disabled\",\"@icon\",\"@label\"],[[30,0,[\"flagForReview\"]],[28,[37,8],[[30,0,[\"submitEnabled\"]],[30,0,[\"notifyModeratorsFlag\"]]],null],\"exclamation-triangle\",\"flagging.flag_for_review\"]],null],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,0,[\"showDeleteSpammer\"]],[[[1,\"      \"],[8,[39,7],[[24,0,\"btn-danger delete-spammer flag-modal__delete-spammer\"]],[[\"@action\",\"@disabled\",\"@icon\",\"@label\"],[[30,0,[\"deleteSpammer\"]],[28,[37,8],[[30,0,[\"submitEnabled\"]]],null],\"exclamation-triangle\",\"flagging.delete_spammer\"]],null],[1,\"\\n\"]],[]],null],[1,\"  \"]],[]]]]]],[\"@closeModal\",\"f\",\"@model\"],false,[\"d-modal\",\"i18n\",\"on\",\"flag-selection\",\"flag-action-type\",\"plugin-outlet\",\"hash\",\"d-button\",\"not\",\"if\",\"reviewable-bundled-action\"]]",
  "moduleName": "discourse/components/modal/flag.hbs",
  "isStrictMode": false
});